import {
  SettingsFormControl,
  SettingsGroup,
  TextInputField
} from '@sequencehq/core-components'

import { MerchantBankAccountDetails } from '../bankDetails.types'

import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'
import { useForm } from '@sequencehq/utils'
import { required } from '@sequencehq/utils/validation'

export const useUsAchAccountForm = ({
  bankDetails,
  showValidationErrors
}: {
  bankDetails?: MerchantBankAccountDetails['value']
  showValidationErrors: boolean
}) => {
  return useForm({
    value: {
      accountName: bankDetails?.usAchDestination?.accountName ?? '',
      accountNumber: bankDetails?.usAchDestination?.accountNumber ?? '',
      bankName: bankDetails?.usAchDestination?.bankName ?? '',
      bankRoutingNumber: bankDetails?.usAchDestination?.bankRoutingNumber ?? ''
    },
    showValidationErrors,
    fieldConfiguration: [
      {
        property: 'accountName',
        validation: [required]
      },
      {
        property: 'accountNumber',
        validation: [required]
      },
      {
        property: 'bankName',
        validation: [required]
      },
      {
        property: 'bankRoutingNumber',
        validation: [required]
      }
    ]
  })
}

export const UsAchAccountForm = ({
  fields
}: {
  fields: ReturnType<typeof useUsAchAccountForm>['fields']
}) => (
  <SettingsGroup title="Account details">
    <SettingsFormControl label="Account name" htmlFor="account-name">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="account-name"
        data-testid="bankDetails.accountName"
        value={fields.accountName.value}
        validationErrors={fields.accountName.validationErrors}
        onChange={e => {
          fields.accountName.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>

    <SettingsFormControl label="Account number" htmlFor="account-number">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="account-number"
        value={fields.accountNumber.value}
        validationErrors={fields.accountNumber.validationErrors}
        onChange={e => {
          fields.accountNumber.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>

    <SettingsFormControl label="Bank name" htmlFor="bank-name">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="bank-name"
        value={fields.bankName.value}
        validationErrors={fields.bankName.validationErrors}
        onChange={e => {
          fields.bankName.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>

    <SettingsFormControl
      label="Bank routing number"
      htmlFor="bank-routing-number"
    >
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="bank-routing-number"
        value={fields.bankRoutingNumber.value}
        validationErrors={fields.bankRoutingNumber.validationErrors}
        onChange={e => {
          fields.bankRoutingNumber.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>
  </SettingsGroup>
)
